import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Row, Switch, Table, Tooltip } from "antd";
import FullHeightContainerLayout from "components/atoms/FullHeightContainerLayout";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faEye, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import CypressTestIds from "../../../cypress/CypressTestIds";
import ProhibitedArea from "../ProhibitedArea";

const { Column } = Table;

const ChangeDataCaptureList = ({ items, onAddCDCDestination, onViewCDCDestination, onEditCDCDestination, onDeleteCDCDestination, onActivateDeactivateCDCItem, permission }) => {
    if (!permission) {
        return <ProhibitedArea></ProhibitedArea>;
    }

    return (
        <Row style={{ flexDirection: "column", flexGrow: 1, height: "100%" }}>
            <Col span={24} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <FullHeightContainerLayout
                    showHeader={false}
                    showFooter={true}
                    content={
                        <Table
                            size="small"
                            rowKey="destinationId"
                            dataSource={items}
                            pagination={false}
                            scroll={{ y: "100vh" }}
                            className="container-height-100"
                            data-testid={CypressTestIds.CDC_LIST_TABLE}
                        >
                            <Column
                                width="6em"
                                render={(value, cdcItem, index) => (
                                    <>
                                        <Tooltip title="Edit CDC Destination">
                                            <FontAwesomeIcon
                                                icon={faPencil}
                                                className={permission.canEdit ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                                onClick={() => permission.canEdit ? onEditCDCDestination(cdcItem.destinationId) : null}
                                                data-testid={CypressTestIds.CDC_LIST_EDIT_BUTTON}
                                            />{" "}
                                        </Tooltip>
                                        <Tooltip title="View CDC Destination">
                                            <FontAwesomeIcon
                                                icon={faEye}
                                                className={permission.canView ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                                onClick={() => permission.canView ? onViewCDCDestination(cdcItem.destinationId) : null}
                                                data-testid={CypressTestIds.CDC_LIST_VIEW_BUTTON}
                                            />{" "}
                                        </Tooltip>
                                    </>
                                )}
                            />
                            <Column
                                width="15%"
                                dataIndex="name"
                                title="Name"
                                ellipsis={{
                                    showTitle: false,
                                }}
                                render={(value, cdcItem, index) => (
                                    <Tooltip placement="topLeft" title={value}>
                                        {value}
                                    </Tooltip>
                                )}
                            />
                            <Column
                                width="15%"
                                dataIndex="description"
                                title="Description"
                                ellipsis={{
                                    showTitle: false,
                                }}
                                render={(value, cdcItem, index) => (
                                    <Tooltip placement="topLeft" title={value}>
                                        {value}
                                    </Tooltip>
                                )}
                            />
                            <Column
                                dataIndex="destinationType"
                                title="Type"
                                ellipsis={{
                                    showTitle: false,
                                }}
                                render={(value, cdcItem, index) => {
                                    return (
                                        <Tooltip placement="topLeft" title={value}>
                                            {value}
                                        </Tooltip>
                                    );
                                }}
                            />
                            <Column
                                dataIndex="createdDate"
                                title="Created Date"
                                ellipsis={{
                                    showTitle: false,
                                }}
                                render={(value, cdcItem, index) => (
                                    <Tooltip placement="topLeft" title={value}>
                                        {moment.utc(value).toDate().toLocaleString()}
                                    </Tooltip>
                                )}
                            />
                            <Column
                                dataIndex="updatedDate"
                                title="Updated Date"
                                ellipsis={{
                                    showTitle: false,
                                }}
                                render={(value, cdcItem, index) => (
                                    <Tooltip placement="topLeft" title={value}>
                                        {moment.utc(value).toDate().toLocaleString()}
                                    </Tooltip>
                                )}
                            />
                            <Column
                                width="8%"
                                dataIndex="active"
                                title={"Active"}
                                ellipsis={{
                                    showTitle: false,
                                }}
                                render={(value, cdcItem, index) => {
                                    return (
                                        <Switch
                                            checked={value}
                                            disabled={!permission.canEdit}
                                            onClick={(checked, event) => {}}
                                            data-testid={CypressTestIds.CDC_LIST_ACTIVE_SWITCH}
                                        ></Switch>
                                    );
                                }}
                            />
                            <Column
                                width="5%"
                                render={(value, cdcItem, index) => {
                                    return (
                                        <Tooltip title="Delete CDC Destination">
                                            <FontAwesomeIcon
                                                icon={faTrashCan}
                                                className={permission.canDelete ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                                onClick={() => permission.canDelete ? onDeleteCDCDestination(cdcItem) : null}
                                                data-testid={CypressTestIds.CDC_LIST_DELETE_BUTTON}
                                            />{" "}
                                        </Tooltip>
                                    );
                                }}
                            />
                        </Table>
                    }
                    footer={
                        <Row className="table-footer-row">
                            <Col span={24} className="footer-right-column">
                                <Button type="primary" disabled={!permission.canAdd} onClick={onAddCDCDestination} data-testid={CypressTestIds.CDC_LIST_ADD_BUTTON}>
                                    <PlusOutlined /> Add Change Data Capture Destination
                                </Button>
                            </Col>
                        </Row>
                    }
                    footerStyle={{ paddingTop: "1rem" }}
                ></FullHeightContainerLayout>
            </Col>
        </Row>
    );
};

export default ChangeDataCaptureList;
